import { useStores } from '@root/src/stores';
import type { AddMultipleProductsToCartMutationVariables } from '@schema/main';
import { observer } from 'mobx-react';
import { useState, type FC } from 'react';

interface RecipeAddAllToCartProps {
  catalogItemsIds: string[];
  isDesktop?: boolean;
}

export const RecipeAddAllToCart: FC<RecipeAddAllToCartProps> = observer(
  ({ catalogItemsIds, isDesktop }) => {
    const { cartStore } = useStores();
    const { updateCartMultiple, productsAmount, isLoadCart } = cartStore;

    const [isChangingCart, setIsChangingCart] = useState(false);

    const onPlusClick = async (): Promise<void> => {
      if (isChangingCart) {
        return;
      }
      setIsChangingCart(true);

      const args: Omit<
        AddMultipleProductsToCartMutationVariables,
        'cartToken'
      > = {
        productsToAddToCart: catalogItemsIds.map(id => ({
          productId: Number(id),
          quantity: Number(productsAmount[id] || 0) + 1
        })),
        continueAnyway: false
      };

      await updateCartMultiple(args);

      setIsChangingCart(false);
    };

    if (!catalogItemsIds?.length || !isLoadCart) return null;
    return (
      <div className='relative'>
        {isChangingCart && (
          <div className='absolute top-0 left-0 z-10 flex items-center justify-center w-full h-full bg-[#D0D0D0]/40 rounded-lg'>
            <div className='dots-loading' />
          </div>
        )}
        <button
          disabled={isChangingCart}
          type='button'
          onClick={onPlusClick}
          aria-label='Купить все ингредиенты'
          className={
            'text-sm h-12 cursor-pointer hover:bg-[var(--main-red)] transition-colors w-full text-center rounded-lg text-white bg-[var(--dark-red)]'
          }
        >
          {isDesktop ? 'Купить все ингредиенты' : 'Добавить все ингредиенты'}
        </button>
      </div>
    );
  }
);

export default RecipeAddAllToCart;
